import { isBefore, parseISO } from 'date-fns'
import * as yup from 'yup'

const imageSchema = yup
	.mixed<File>()
	.test('fileType', 'A imagem deve ser PNG ou JPEG', (file) =>
		file ? ['image/png', 'image/jpeg'].includes(file.type) : false
	)

const editImageSchema = yup
	.mixed<File | string>()
	.test('fileType', 'A imagem deve ser PNG ou JPEG', (file) => {
		if (!file) return false
		if (typeof file === 'string') return true

		return ['image/png', 'image/jpeg'].includes(file.type)
	})

export const addPopupsSchema = yup.object({
	// accessTime: yup.string(),
	classId: yup
		.object({
			value: yup.number().required(),
			label: yup.string().required(),
		})
		.required('Turma é obrigatória'),
	link: yup.string().required(),
	desktopPicture: yup
		.array()
		.of(imageSchema)
		.ensure()
		.min(1, 'Imagem Desktop é obrigatória'),
	mobilePicture: yup
		.array()
		.of(imageSchema)
		.ensure()
		.min(1, 'Imagem Mobile é obrigatória'),
	startAt: yup.string().required('Data inicial é obrigatória'),
	endAt: yup
		.string()
		.required('Data final é obrigatória')
		.test(
			'endAt-after-startAt',
			'Data final não pode ser anterior a data inicial',
			// eslint-disable-next-line func-names
			function (value) {
				const { startAt } = this.parent

				if (!value || !startAt) return false

				const endDate = parseISO(value)
				const startDate = parseISO(startAt)

				return !isBefore(endDate, startDate)
			}
		),
	delay: yup.string().optional(),
	forPaidClasses: yup.string().notRequired(),
	onOpen: yup.string().notRequired(),
	onClose: yup.string().notRequired(),
})

export const editPopupsSchema = yup.object({
	classId: yup
		.object({
			value: yup.number().required(),
			label: yup.string().required(),
		})
		.required('Turma é obrigatória'),
	link: yup.string().required(),
	desktopPicture: yup.array().of(editImageSchema).ensure().optional(),
	mobilePicture: yup.array().of(editImageSchema).ensure().optional(),
	startAt: yup.string().required('Data inicial é obrigatória'),
	endAt: yup
		.string()
		.required('Data final é obrigatória')
		.test(
			'endAt-after-startAt',
			'Data final não pode ser anterior a data inicial',
			// eslint-disable-next-line func-names
			function (value) {
				const { startAt } = this.parent

				if (!value || !startAt) return false

				const endDate = parseISO(value)
				const startDate = parseISO(startAt)

				return !isBefore(endDate, startDate)
			}
		),
	delay: yup.string().nullable().optional(),
	forPaidClasses: yup.string().notRequired(),
	onOpen: yup.string().notRequired(),
	onClose: yup.string().notRequired(),
})
